import styled, {css, keyframes} from 'styled-components';
import {
    colors,
    mobileMediaQuery,
    notWebMediaQuery,
    sizes,
    tabletMediaQuery,
    webMediaQuery,
} from './../../styles';
import BigButton from './../BigButton';
import JoystickIcon from './../../assets/games_icon.png';

export const Container = styled.div`
    cursor: pointer;
    position: relative;
    display: flex;
    width: 100%;
    min-width: 323px;
    height: ${props =>
        props.horizontal
            ? 'auto'
            : props.isEpisode
            ? 'calc(11.6vw + 62px)'
            : '11.6vw'};
    max-height: ${props =>
        props.horizontal ? '66px' : props.isEpisode ? '196px' : '134px'};

    @media (min-width: ${sizes.xlarge}) {
        height: ${props =>
            props.horizontal
                ? '6vw'
                : props.isEpisode
                ? 'calc(12.6vw + 62px)'
                : '12.6vw'};
        max-height: ${props =>
            props.horizontal ? '85px' : props.isEpisode ? '232px' : '170px'};
    }
    @media (min-width: ${sizes.max}) {
        height: ${props =>
            props.horizontal ? '140px' : props.isEpisode ? '253px' : '198px'};
        max-height: ${props =>
            props.horizontal ? '102px' : props.isEpisode ? '245px' : '198px'};
    }
    border-radius: 0px;
    transition: transform 0.35s cubic-bezier(0.68, -0.51, 0.22, 1.68);
    margin: ${props => (props.horizontal ? '0' : 'auto')};
    ${props =>
        !props.horizontal &&
        css`
            &:hover {
                ${webMediaQuery} {
                    transform: scale(1.05);
                    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
                }
            }
        `}

overflow: hidden;

${props => props.horizontal && `min-height: 112px;`}

${({horizontal, isEpisode}) =>
    !horizontal &&
    isEpisode &&
    css`
        ${webMediaQuery} {
            width: 100%;
            margin: 0px;
            height: 0px;
            max-height: initial;
            min-width: initial;
            padding-bottom: calc(74.43 / 100 * 100%);
        }

        ${tabletMediaQuery} {
            height: fill-available;
            max-height: 238px;
            max-width: 313px;

            height: 238px;
            width: 313px;
            margin: 0;
        }

        ${mobileMediaQuery} {
            height: fill-available;
            max-height: 245px;
            max-width: 323px;

            height: 245px;
            width: 323px;
            margin: 0;
        }
    `}

${({horizontal, isEpisode}) =>
    !horizontal &&
    !isEpisode &&
    css`
        ${notWebMediaQuery} {
            width: 100%;
            margin: 0px;
            height: 0px;
            min-width: initial;
            padding-bottom: calc(9 / 16 * 100%);
        }
    `}

${({type}) =>
    type === 'game' &&
    css`
        ${notWebMediaQuery} {
            padding-bottom: calc(13.93 / 16 * 100%);
        }
    `}

${({cnito}) =>
    cnito &&
    css`
        border-radius: 8px;
    `}

    ${props =>
        !props.horizontal &&
        props.cnito &&
        (props.type === 'game' || props.isEpisode) &&
        css`
            border-radius: 12px;
            border: 6px solid #fff;
            box-sizing: border-box;
            background: #fff;
        `}
`;

export const OverlayClick = styled.div`
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    z-index: 2;
`;

export const Background = styled.div`
    position: relative;
    ${props =>
        !props.horizontal &&
        css`
            position: absolute;
            left: 0px;
            right: 0px;
            top: 0px;
            bottom: ${props.isEpisode && !props.cnito ? '62px' : '0px'};
            transition: none !important;
        `}

    ${props =>
        props.background &&
        css`background: url('${props.background}');`}

background-repeat: no-repeat;
    background-size: cover;
    background-position: 50% 50%;
    border-radius: ${props =>
        props.horizontal
            ? '2px'
            : '0px'};
    flex: 0.45;
    background-color: #211921;
    transition: 3s all ease-in-out;
    overflow: hidden;
    ${props =>
        props.horizontal &&
        css`
            flex-basis: 173px;
            max-width: 173px;
            max-height: 140px;
        `}

    ${mobileMediaQuery} {
        ${props =>
            !props.horizontal &&
            (props.isEpisode || (props.type === 'game' && !props.featured)) &&
            !props.cnito &&
            css`
                bottom: 54px;
            `}
    }

    ${props =>
        !props.horizontal &&
        props.cnito &&
        (props.type === 'game' || props.isEpisode) &&
        css`
            bottom: 0px;
            border-radius: 12px;
        `}
`;

const logoAnimation = keyframes`
0% {
    left: -100%;

}

100% {
    left: 5%;
}
`;

const cartoonitoLogoAnimation = keyframes`
0% {
    left: -100%;
}

100% {
    left: 50%;
}
`;

export const ShowLogo = styled.img`
    position: absolute;
    left: 5%;
    top: calc(50%);
    width: auto;
    height: 60%;
    transform: translateY(-50%);
    left: -100%;

    ${({animated}) =>
        animated &&
        css`
            animation: ${logoAnimation} 0.8s ease-in-out;
            animation-fill-mode: forwards;
        `}

    ${({cnito}) =>
        cnito &&
        css`
            animation: ${cartoonitoLogoAnimation} 0.8s ease-in-out;
            left: 50%;
            transform: translateX(-50%);
            top: initial;
            bottom: 14px;
            height: 26%;
            width: 100%;
            object-fit: contain;
        `}
`;

const characterAnimation = keyframes`
0% {
    top: 100%;
}

100% {
    top: 16px;
}
`;

export const ShowCharacter = styled.img`
    position: absolute;
    top: 16px;
    left: 30%;
    width: 80%;
    height: auto;
    top: 100%;

    ${({animated}) =>
        animated &&
        css`
            animation: ${characterAnimation} 0.4s ease-in-out;
            animation-fill-mode: forwards;
        `}

    ${({cnito}) =>
        cnito &&
        css`
            width: 100%;
            left: 0px;
            right: 0px;
            top: 16px;
            bottom: 114px;
            transform: none;
            height: calc(100% - 16px - 14px - 8px - 26%);
            object-fit: contain;
        `}
`;

export const Footer = styled.div`
    flex: 1;
    ${props =>
        !props.horizontal
            ? `
        position: absolute;
        width: calc(100% - 24px);
        height: 52px;
        left: 0px;
        bottom: 0px;
        color: ${colors.cartoonBlack};
        background: #fff;
        `
            : `
        background: transparent;
        justify-content: flex-start;
        color: #fff;
        max-width: 50%;
`}
    display: flex;
    flex-direction: column;
    padding: 5px 12px;
    border-radius: 0px;

    ${mobileMediaQuery} {
        padding-bottom: 0;
    }

    ${({cnito}) =>
        cnito &&
        css`
            box-sizing: border-box;
            width: 100%;
            justify-content: space-around;
        `}

    ${props =>
        !props.horizontal &&
        props.cnito &&
        (props.type === 'game' || props.isEpisode) &&
        css`
            display: none;
            padding: 0;
            height: 0;
        `}
`;

export const Highlight = styled.div`
    position: absolute;
    left: 0px;
    top: 16px;
    background-color: ${colors.cartoonBlack};
    font-size: 12px;
    font-weight: bold;
    text-transform: uppercase;
    padding: 0.25rem 0.5rem;
    color: #fff;
`;

export const Duration = styled(Highlight)`
    text-transform: lowercase;
    left: 12px;
    font-size: 10px;
    top: initial;
    bottom: calc(62px + 0.75rem);
    ${props =>
        props.horizontal &&
        `
    left: 5px;
    bottom: 4px;
`}

    ${props =>
        props.live &&
        css`
            top: 16px;
            left: 7px;
            bottom: initial;
            text-transform: uppercase;
            display: flex;
            flex-direction: row;
            align-items: center;
            background-color: rgba(8, 0, 8, 0.8);
            border-radius: 2px;
            padding: 6px;
        `}
`;

const favouriteButtonAnimation = keyframes`
0% {
    left: 100%;
}

100% {
    left: 0%;
}
`;

export const FavouriteButton = styled.div`
    ${props => props.active && `background-color: ${colors.pink};`}
    ${props =>
        !props.active &&
        `background-color: ${colors.cartoonBlack};`}
    min-width: 24px;
    min-height: 24px;
    width: 24px;
    height: 24px;
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 2;
    flex: 0;
    flex-basis: 24px;
    padding: 0.5rem;
    
    justify-content: center;
    align-items: center;
    svg rect {
        fill: #fff;
    }
`;

export const heartAnimation = keyframes`
0% {
    transform: rotate(0deg);
}

50% {
    transform: rotate(40deg);
}

75% {
    transform:  rotate(-30deg);
}



100% {
    transform: rotate(0deg);
}
`;

export const HeartIconContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    pointer-events: none;
    transform-origin: center bottom;
    ${({animated}) =>
        animated.toString() === 'true' &&
        css`
            animation: ${heartAnimation} 0.5s ease;
        `}
`;

export const FavouriteIcon = styled.img`
    background-color: ${props => (props.active ? colors.pink : '#000')};
    width: 26px;
    height: 26px;
    border-radius: 100%;
    z-index: 3;
    padding: 0.6rem;
    margin-right: 2rem;
    object-fit: contain;
`;

export const PlayButton = styled(Highlight)`
    left: initial;
    top: initial;
    right: 0.5rem;
    bottom: 7px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 48px;
    padding: 0px;
    svg rect {
        fill: #fff;
    }
    z-index: 1;

    ${props => !props.unlocked && 'background-color: #009bdf;'};

    ${mobileMediaQuery} {
        ${({type}) =>
            type === 'game' &&
            css`
                width: 38px;
                height: 38px;

                img {
                    width: 22px;
                    height: 22px;
                }
            `};
    }
`;

export const Title = styled.p`
    font-family: 'AvenirNextRoundedStd';
    flex: 1;
    font-weight: bold;
    font-size: ${props => (props.horizontal ? `16px` : `16px`)};
    line-height: ${props => (props.horizontal ? `21px` : `24px`)};
    text-transform: uppercase;
    padding: 0px;
    margin: 0px;
    white-space: ${props => (props.horizontal ? `inherit` : `nowrap`)};
    max-width: calc(100% - 44px);
    overflow: hidden;
    text-overflow: ellipsis;
    flex-basis: unset;
    flex-grow: 0;
    height: auto;
    color: ${props => (props.horizontal ? `rgb(157, 157, 157)` : 'black')};

    ${mobileMediaQuery} {
        line-height: ${props => (props.horizontal ? `21px` : `22px`)};
    }

    ${({cnito}) =>
        cnito &&
        css`
            line-height: 15px;
            font-family: 'Oduda';
            font-weight: 600;
        `}
`;

export const SubTitle = styled(Title)`
    font-weight: 500;
    font-size: ${props => (!props.horizontal ? `16px` : `14px`)};
    line-height: ${props => (!props.horizontal ? `31px` : `27px`)};
    text-transform: capitalize;
    color: ${props => (props.horizontal ? `rgb(215, 215, 215)` : `black`)};

    ${mobileMediaQuery} {
        font-size: ${props => (!props.horizontal ? `16px` : `14px`)};
        line-height: ${props => (!props.horizontal ? `22px` : `27px`)};
    }

    ${({cnito}) =>
        cnito &&
        css`
            line-height: 22px;
            font-family: 'Oduda';
            font-weight: 600;
        `}
`;

export const LiveCircle = styled.div`
    height: 9px;
    width: 9px;
    border-radius: 100%;
    background: rgb(237, 0, 128);
    margin-right: 5px;
`;

export const Joystick = styled.img.attrs(() => ({
    src: JoystickIcon,
}))`
    height: 28px;
    width: 28px;
    object-fit: contain;
`;

export const GameIconContainer = styled.div`
    position: absolute;
    right: -1px;
    bottom: -1px;
    border-radius: 12px 0 12px 0;
    background-color: #fff;
    padding: 10px;
    box-sizing: border-box;
    max-width: 50px;
    max-height: 40px;

    svg {
        max-width: 100%;
        height: 100%;

        use {
            fill: #000;
        }
    }
`;

export const DurationContainer = styled.div`
    position: absolute;
    right: -1px;
    bottom: -1px;
    border-radius: 12px 0 12px 0;
    background-color: #fff;
    color: #000;
    padding: 8px;
    box-sizing: border-box;
    height: auto;
    display: flex;
    align-items: center;
    font-size: 15px;
    line-height: 18px;
    font-family: 'Oduda';
    font-weight: 600;

    img {
        width: auto;
        height: 21px;
        object-fit: contain;
        margin-right: 2px;
    }
`;
